import { createI18n } from 'vue-i18n'

import nl from '../languages/nl-NL.json'
import en from '../languages/en-US.json'
import de from '../languages/de-DE.json'
import fr from '../languages/fr-FR.json'
import es from '../languages/es-ES.json'

const messages = {
  nl,
  en,
  de,
  fr,
  es
}

// Composition API only (no Vue 2 VueI18n class). $t / $rt / $d / $n come from globalInjection.
const i18n = createI18n({
  globalInjection: true,
  locale: 'nl',
  fallbackLocale: 'en',
  messages,
  // Locale files are app-owned; HTML is rendered intentionally via v-html.
  warnHtmlMessage: false
})

export function setGlobalLocale (locale) {
  i18n.global.locale.value = locale
}

export function getGlobalLocale () {
  return i18n.global.locale.value
}

export default i18n
